import PropTypes from 'prop-types';
import React, { Component } from 'react';
import * as d3 from 'd3';
import styles from './AutoWidthSelect.css';
import withStyles from '../../decorators/withStyles';


class AutoWidthSelect extends Component {

  static propTypes = {
    options: PropTypes.array.isRequired,
    defaultValue: PropTypes.any.isRequired,
    handleChange: PropTypes.func.isRequired,
    listOpen: PropTypes.bool.isRequired,
    // value: PropTypes.any.isRequired
  };

  static defaultProps = {
    listOpen: false
  };

  constructor(props) {
    super(props);
    this.state = {
      width: 300,
      value: props.defaultValue,
      refs: []
    };
  }

  componentDidUpdate(props) {
    if (props.defaultValue !== this.props.defaultValue) {
      this.setState({value: this.props.defaultValue});
    }
  }

  handleClick = () => {
    this.setState({listOpen: !this.state.listOpen});
  };

  handleListClick = value => {
    this.setState({value: this.props.options.find(opt => opt.value === value).value});
    this.props.handleChange(value);
  };

  setTxContent = el => {
    // this.state.refs.push(el);
    d3.select(el).attr("tx-content", "block");
    // d3.select(el).attr("tx-dynamic", "disabled");
  };

  render() {
    const { options, defaultValue } = this.props;
    const stateValue = options.find((opt) => opt.value === this.state.value);
    let selectorValue;

    if (stateValue) {
      selectorValue = stateValue;
    } else {
      selectorValue = options.find((opt) => opt.value === defaultValue);
    }

    if (!selectorValue) {
      return null;
    }

    return (
      <span className="AutoWidthSelect" key={Math.random().toString()}>
        {(options.length > 1) ?
          <div>
            <div className="inline-selector"
                 value={defaultValue}
                 onClick={this.handleClick}>
              <div className="selector-value" ref={this.setTxContent}>{selectorValue.text}</div>
              <div className={"selector-options " + (this.state.listOpen ? "open" : "")}>
              {options.filter(option => option.value != this.state.value).map((option, i) => {
                return <div className="selector-option" onClick={this.handleListClick.bind(null, option.value)} key={i.toString()} ref={this.setTxContent}>{option.text}</div>
              })}
              </div>
            </div>
          </div>
          : (options.length === 1 ? <span>{options[0].value}</span> : null)}
      </span>
    );
  };

}

export default withStyles(styles)(AutoWidthSelect);
